import React from 'react';
import './checkbox.css';
import { classnames } from '../../../../utils/classnames';
import InputErrors, {withErrors} from "../inputErrors/inputErrors";
import { useTranslation } from 'react-i18next';

export default function Checkbox({
    onChange,
    className = '',
    required,
    checked,
    label,
    errors = null,
    description,
    disabled,
    uniqueKey,
    fieldId,
    default_value,
    allow_modification,
    display = true,
    ...rest
}) {
    const { t } = useTranslation()
    const toggleChange = React.useCallback(
		event => {
			onChange(event, { checked: event.target.checked });
		},
		[onChange]
	);

    const getKey = (element = '') => uniqueKey ? `field_${uniqueKey}${element ? '_' + element : ''}` : null;

    if (!display) {
        return null
    }

    return (
        <div className='neo-checkbox-container'>
            <label className={`neo-checkbox-label ${disabled ? 'disabled' : ''}`}>
                <input
                    id={getKey()}
                    className={classnames('neo-checkbox', className, {'error': withErrors(errors)})}
                    aria-describedby={`${getKey('description')} ${getKey('error')}`}
                    aria-invalid={withErrors(errors)}
                    aria-required={required}
                    aria-checked={checked}
                    type='checkbox' 
                    checked={checked}
                    disabled={disabled}
                    onChange={toggleChange} 
                    {...rest}
                />
                <div className='neo-checkbox-label-and-subtitle'>
                    <span className='neo-checkbox-label-title' htmlFor={getKey()}>
                        {label}
                        {required && <span aria-label={t('widget.required-field')} className='neo-checkbox-required'>*</span>}
                    </span>
                    {description && <p className='neo-checkbox-subtitle' id={getKey('description')}>{description}</p>}
                    {!checked && <InputErrors id={getKey('error')} errors={errors}/>}
                </div>
            </label>
        </div>
    )
}